var map = {
	"./hotel1.png": 28429,
	"./hotel2.png": 14454,
	"./hotel3.png": 11391,
	"./hotel4.png": 60064,
	"./hotel5.png": 38185,
	"./hotel6.png": 23570,
	"./hotel7.png": 38395,
	"./hotel8.png": 58508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80669;